<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">退款</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="机构" required prop="institutionCode">
                <el-select v-model="addForm.institutionCode" @change="insChange" placeholder="请选择机构" style="width: 100%">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="残疾人" required prop="elderlyName">
                <el-input v-model="addForm.elderlyName" placeholder="选择残疾人" disabled style="">
                  <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
                  <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="账户信息">
                <el-input v-model="elderlyInfoStr" type="textarea" :rows="3" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="退款金额" required prop="returnBalance">
                <el-input v-model="addForm.returnBalance" placeholder="输入退款金额" style=""></el-input>
              </el-form-item>
            </el-col>



          </el-row>


        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">提交</el-button>
      </div>
    </div>

    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>

  </div>
</template>

<script>

import { timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Elderly from "@/views/Elderly/Comm/ElderlyInsSigning3";


export default {
  name: 'Add',
  props:['arr_ins'],
  data() {
    return {

      loading: false,

      showModalGetElderly:false,


      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        institutionCode:'',

        userCode:'',
        elderlyCode:'',
        elderlyName:'',

        returnBalance:'',

      },

      successInfo:'',

      rechargeType_arr:[
        {value:1,label:"现金"},
        {value:2,label:"支付宝"},
        {value:3,label:"微信"},
        {value:4,label:"刷卡"},
        {value:5,label:"补贴"},
        {value:6,label:"转账"},
      ],


      rules:{
        elderlyName:[
          { required: true, message: '请选择老人', trigger: 'blur' },
          { required: true, message: '请选择老人', trigger: 'change' },
        ],
        returnBalance:[
          { required: true, message: '请输入退款金额', trigger: 'blur' },
          { required: true, message: '请输入腿款金额', trigger: 'change' },
        ],

      },

      type:'',

      elderlyInfo:null,
      elderlyInfoStr:'',


    }
  },
  components:{
    Elderly
  },
  methods: {
    init(type){
      this.type = type;

      this.$refs.addForm.resetFields();

      this.elderlyInfoStr = '';

    },
    closeSelf() {
      this.$emit("closeAdd");
    },

    insChange(val){
      this.addForm.institutionCode = val;

      this.addForm.elderlyCode = '';
      this.addForm.elderlyName = '';

    },


    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init(this.type,this.addForm.institutionCode);
    },
    setElderly(row){
      this.addForm.userCode = row.userCode;
      this.addForm.elderlyCode = row.elderlyCode;
      this.addForm.elderlyName = row.name;

      this.getElderlyInfo();
    },
    clearElderly(){
      this.addForm.userCode = '';
      this.addForm.elderlyCode = '';
      this.addForm.elderlyName = '';
    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.elderlyInfo.checkinStatus == 2){
        this.$message.info("请先办理退住，才能退款");
        return;
      }

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"RefundRecord/Add",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeAdd");
              this.$emit("getList");

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },

    getElderlyInfo(){

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ElderlyAdm/ElderlyInfo2",
        data: this.addForm
      }).then(
          (response) => {

            if (response.data.error == 0) {
              this.elderlyInfo = response.data.data.elderlyDTO;

              let elderlyFund = this.elderlyInfo.elderlyFund;

              this.elderlyInfoStr = '';
              this.elderlyInfoStr += '余额:'+elderlyFund.balance+',';
              this.elderlyInfoStr += '预交金:'+elderlyFund.advance+',';
              this.elderlyInfoStr += '备用金:'+elderlyFund.imprest+'\n';
              this.elderlyInfoStr += '应退款:'+(elderlyFund.balance+elderlyFund.advance+elderlyFund.imprest)+'\n';

              let st = this.elderlyInfo.checkinStatus == 2?'入住中':'已退住';
              this.elderlyInfoStr += '入住状态:'+st+'\n';


              this.addForm.returnBalance = elderlyFund.balance+elderlyFund.advance+elderlyFund.imprest;

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },


  }
}


</script>
<style lang="scss" scoped>

</style>
